exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".home-wrapper[data-v-a9584700]{-webkit-box-sizing:border-box;box-sizing:border-box}", ""]);

// exports
